import validationStore from "../../../helpers/regexValidators";

export default () => ({
  initialState: {
    email: { value: "", error: "" },
  },
  validationStateSchema: {
    email: {
      required: true,
      validator: {
        regEx: validationStore.email,
        error: "Favor de introducir un formato de email válido.",
      },
    },
  },
});
